export default __webpack_public_path__ + "static/media/Pressed_button_used_controller.210758ab.svg";